/* eslint-disable */
import api from '@/api';
import {
  CONFLICT,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = `${process.env.VUE_APP_BASE_API}/Indicoo`;
const HANDLED_ERRORS = [NOT_ACCEPTABLE, CONFLICT, UNPROCESSABLE_ENTITY, UNAUTHORIZED, NOT_FOUND];

export default {
  getInfo: async () => {
    const response = await api.get(baseAPI);
    let errors = null;
    const { status } = response;

    if (HANDLED_ERRORS.includes(status)) {
      errors = {
        status,
        statusText: response.statusText || response.data.message,
      };
    }

    const { data } = response;

    return {
      data,
      errors,
    };
  },
};
